import { IFundingCampaign } from "./IWebsiteDataV3";

export const FundingCampaign: React.FC<{ campaign: IFundingCampaign; }> = ({ campaign }) => {

    return (
        <div style={{ margin: 10 }}>
            <div className="cause-layout-1">

                <figure className="cause-img">
                    <img src={campaign.coverImagePath} />
                </figure>

                <div className="cause-content text-center">
                    <h5><a target="_blank" href={campaign.url}>{campaign.title}</a></h5>

                    {campaign.goalWidgetId && (
                        <givebutter-widget id={campaign.goalWidgetId}></givebutter-widget>
                    )}

                    <div className="campaign-cta-bar">
                        {campaign.buttonWidgetId && (
                            <givebutter-widget id={campaign.buttonWidgetId}></givebutter-widget>
                        )}

                        <a target="_blank" href={campaign.url}>Learn More...</a>
                    </div>
                </div>
            </div>
        </div>
    )
}